export default __webpack_public_path__ + "static/media/money-back@2x.6f4dfe9b.png";